module.exports = __webpack_public_path__ + "img/copyright-white.4be2774a.png";